module.exports = require('./helpers/bundle-url').getBundleURL('c30iu') + "logo.c51670a8.svg";